module.exports = "app-weather-card {\n  margin: 1em; }\n"